<div class="row">
  <div class="col-2 section-label">
    <h6 class="m-0 ml-3">ข้อมูลลูกค้า</h6>
  </div>
</div>

<div class="row mt-3">
  <div class="col-12 text-right">
    <button class="btn btn-info m-2" (click)="displayPopup()">แสดงข้อมูล</button>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>รหัสสถาบันการเงิน</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{getDAList.FI_Code}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label>ข้อมูล ณ วันที่</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{ getDAList.DatasetDate | thaidate:'short'  }}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>เลขที่บัตรประจำตัวประชาชน</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="idmasking" readonly>
  </div>
  <div class="col-2 text-right">
    
  </div>
  <div class="col-3">
    
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>รหัสประเภทลูกค้า</label>
  </div>
  <div class="col-3">
      <input type="text" class="form-control" value="{{getDAList.InvolvedPartyType}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label>รหัสหน่วยราชการ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{getDAList.GovernmentAgencyCode}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>หมายเลขบัญชี</label>
  </div>
  <div class="col-3">
    <textarea class="form-control" rows="3" [(ngModel)]="accmaskingAll" readonly></textarea>
  </div> 
</div>
<hr class="mb-3">

<div class="row mt-3">
  <div class="col-2 text-right">
    <!-- <label>คำนำหน้า</label> -->
    <label>ชื่อ</label>
  </div>
  <div class="col-3">
    <!-- <input type="text" class="form-control" value="" readonly> -->
    <input type="text" class="form-control" value="{{getDAList.FirstName}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label>นามสกุล</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{getDAList.LastName}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>ชื่อกลาง</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{getDAList.MiddleName}}" readonly>
  </div> 
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>วันเดือนปีเกิด</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{ getDAList.Birthdate | thaidate:'short' }}" readonly>
  </div>
  <div class="col-2 text-right">
    
  </div>
  <div class="col-3">
    
  </div>
</div>

<hr class="mb-3">

<div class="row">
  <div class="col-6 offset-md-2">
    <label>
    ที่อยู่ตามบัตรประชาชน
    </label>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label class="">ที่อยู่</label>
  </div>
  <div class="col-8">
    <input type="text" class="form-control" value="{{getDAList.RegisteredAddress}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>แขวง/ตำบล</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{getDAList.RegisteredSubDistrict}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label>เขต/อำเภอ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{getDAList.RegisteredDistrict}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>จังหวัด</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{getDAList.RegisteredProvince}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label>รหัสไปรษณีย์</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{getDAList.RegZipcode}}" readonly>
  </div>
</div>



<hr class="mb-3">

<div class="row">
  <div class="col-6 offset-md-2">
    <label>
    ที่อยู่ที่ติดต่อได้
    </label>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label class="">ที่อยู่</label>
  </div>
  <div class="col-8">
    <input type="text" class="form-control" value="{{getDAList.ContactAddress}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>แขวง/ตำบล</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{getDAList.ContactSubDistrict}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label>เขต/อำเภอ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{getDAList.ContactDistrict}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>จังหวัด</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{getDAList.ContactProvince}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label>รหัสไปรษณีย์</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{getDAList.ContactZipcode}}" readonly>
  </div>
</div>


<div class="row mt-3">
  <div class="col-2 text-right">
    <label>เบอร์โทรศัพท์</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="telmasking" readonly>
  </div>
  <div class="col-2 text-right">
    <label>เบอร์โทรศัพท์มือถือ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="mobilemasking" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>อีเมล์</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="emailmasking" readonly>
  </div>
  <div class="col-2 text-right">
   
  </div>
  <div class="row">
    &nbsp;
   </div>
   <div class="row">
    &nbsp;
   </div>
  
</div>

<!-- <hr class="mb-3">

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>รหัสที่ตั้ง</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    
  </div>
  <div class="col-3">
    
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>เบอร์โทรศัพท์</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    <label>เบอร์โทรศัพท์มือถือ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>อีเมล์</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    <label>สถานะการค้ำประกัน</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>สถานะการมีภาระผูกพัน</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    <label>สถานะการสมัครใช้งานพร้อมเพย์</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
</div>

<hr class="mb-3">
<div class="row">
  <div class="col-2 section-label">
    <h6 class="m-0 ml-3">ข้อมูลบัญชีเงินฝาก</h6>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>รหัสสถาบันการเงิน</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    <label>ข้อมูล ณ วันที่</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
</div>
<div class="row mt-3">
  <div class="col-2 text-right">
    <label>เลขที่บัญชี</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    <label>ชื่อบัญชี</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
</div>
<div class="row mt-3">
  <div class="col-2 text-right">
    <label>รหัสสาขา</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    <label>รหัสเลขที่บัญชี</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
</div>
<div class="row mt-3">
  <div class="col-2 text-right">
    <label>ประเภทบัญชีเงินฝาก</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    <label>จำนวนต้นเงินฝาก</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
</div>
<div class="row mt-3">
  <div class="col-2 text-right">
    <label>จำนวนดอกเบี้ยค้างจ่าย</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    <label>จำนวนดอกเบี้ยจ่ายล่วงหน้า</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
</div>
<div class="row mt-3">
  <div class="col-2 text-right">
    <label>สถานะบัญชีเงินฝากที่เป็นประกันสินเชื่อ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    <label>จำนวนเงินฝากที่เป็นประกันสินเชื่อ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
</div>
<div class="row mt-3">
  <div class="col-2 text-right">
    <label>เลขที่บัญชีสินเชื่อ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    <label>สถานะการถูกอายัดบัญชี</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
</div>
<div class="row mt-3">
  <div class="col-2 text-right">
    <label>เลขประจำตัวที่ใช้เปิดบัญชี</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    <label>ประเภทลูกค้า</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
</div>
<div class="row mt-3">
  <div class="col-2 text-right">
    <label>รหัสหน่วยราชการ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
  <div class="col-2 text-right">
    <label>อัตราส่วนการเป็นเจ้าของบัญชี (%)</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="" readonly>
  </div>
</div> -->
 

<!-- Modal detail-->
<div class="modal" [ngStyle]="{'display':displayStyle}"aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-m">
    <div class="modal-content">

      <div class="modal-body" [formGroup]="form" style="background-color: #a7c4e6">

        <div class="row mt-3">
          <div class="col-12 text-center">
            <h5 class="modal-title" style="font-weight: bold">Supervisor Authorization</h5>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-3 offset-md-1 text-right">
            <label class="font-weight-bold">Username :</label>
          </div>
          <div class="col-6">
            <input type="text" class="form-control" name="username" placeholder="Username" formControlName="username">
          </div>
        
        </div>
        <div class="row mt-3">
          <div class="col-2 offset-md-1 text-right">
            
          </div>
          <div class="col-6 text-left">
            <span class="text-danger ml-5"
            *ngIf="(formControl.username.touched || submitted) && formControl.username.errors?.required">
            กรุณาระบุ Username
          </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-3 offset-md-1 text-right">
            <label class="font-weight-bold">Password :</label>
          </div>
          <div class="col-6">
            <input type="password" class="form-control" name="Password" placeholder="Password" formControlName="password">
          </div>
         
        </div>
        <div class="row mt-3">
          <div class="col-2 offset-md-1 text-right">
            
          </div>
          <div class="col-6 text-left">
            <span class="text-danger ml-5"
            *ngIf="(formControl.password.touched || submitted) && formControl.password.errors?.required">
            กรุณาระบุ Password
          </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6 text-right">
            <button class="btn btn-primary" (click)="authorize()">
              ยืนยัน
            </button>
          </div>
          <div class="col-6 text-left">
            <button type="button" class="btn btn-info" (click)="close()">ปิด</button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-3 text-center">
           &nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customer-da-data/customer-da-data.component.html